module.exports = __webpack_public_path__ + "static/media/concentricCircle2.d1435c84.png";